<template>
  <div v-if="boo_modal" class="modal fade show">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Seleccionar Producto</h5>
          <button type="button" class="close" @click="closeModal">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body table-responsive">
          <table class="table table-hover dt-responsive nowrap">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Unidad</th>
                <th>Stock</th>
                <th>Precio</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in products" :key="index">
                <td>{{ product.label }}</td>
                <td>{{ product.label_unit }}</td>
                <td>{{ parseInt(product.stock) }}</td>
                <td>
                  <button @click="selectProduct(product)" class="btn btn-primary btn-sm w-100">
                    {{ product.price }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      required: true,
    },
    boo_modal: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    selectProduct(product) {
      if (product.type == 2) {
        this.$emit("selectProductList", product);
      } else {
        this.$emit("selectProduct", product);
      }
      // if (product.stock > 0) {
      //   this.$emit("selectProduct", product);
      // }

    },
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1050;

}

.modal-dialog {
  margin: 0;
  max-width: 90%;
}

.modal-content {
  width: 100%;
}

.table-responsive {
  overflow-x: auto;
  white-space: nowrap;
}
</style>